module.exports = __webpack_public_path__ + "img/pc_group_banner.4debf00.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterAd/image/pc_group_banner.png
// module id = bNAf
// module chunks = 0